import { observer } from "mobx-react";
import React from "react";

import { LiveStreamStatus } from "@gp/models";

import { useRootAppStore } from "@hooks";
import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";

export const LiveStreamIcon = observer(function LiveStreamIcon(props: {
	liveStreamStatus?: LiveStreamStatus;
}) {
	const { userAuthStore } = useRootAppStore();

	//do not show live stream icon if notification favorites button is displayed
	if (isCapacitorPlatform() && userAuthStore.isLoggedIn) {
		return null;
	}

	//show live stream icon if livestream property exists and is not finished
	if (
		props.liveStreamStatus == null ||
		props.liveStreamStatus === LiveStreamStatus.Finished
	) {
		return null;
	}

	return (
		<div className="at-actionLiveStream match__details__btn btn btn--square--reset btn--ghost">
			{props.liveStreamStatus === LiveStreamStatus.Live ? (
				<i className="match__details__icon u-icon u-icon--sml u-icon--action--stream--active" />
			) : (
				<i className="match__details__icon u-icon u-icon--sml u-icon--action--stream--upcoming" />
			)}
		</div>
	);
});
